import { useState } from 'react';
import { ContractsList } from './ContractsList';
import { ContractViewer } from './ContractViewer';
import { useContractsStore } from '@/store/contracts';
import { cn } from '@/lib/utils';
import { PanelLeft } from 'lucide-react';

export function ContractsPage() {
  const { activeContract } = useContractsStore();
  const [listVisible, setListVisible] = useState(true);

  return (
    <div className="flex h-full w-full min-h-0 min-w-0">
      {/* Sidebar list */}
      <div
        className={cn(
          'shrink-0 border-r border-white/10 flex flex-col min-h-0',
          'transition-all duration-200',
          listVisible ? 'w-[320px]' : 'w-0 overflow-hidden border-r-0',
        )}
      >
        <ContractsList />
      </div>

      {/* Main viewer area */}
      <div className="flex-1 flex flex-col min-h-0 min-w-0 relative">
        {/* Toggle list button */}
        <button
          onClick={() => setListVisible((v) => !v)}
          title={listVisible ? 'Сховати список' : 'Показати список'}
          className="absolute top-3 left-3 z-10 p-1.5 rounded-md bg-white/5 border border-white/10 text-white/40 hover:text-white hover:bg-white/10 transition-colors"
        >
          <PanelLeft className="w-4 h-4" />
        </button>

        <ContractViewer />
      </div>
    </div>
  );
}
